<h1 mat-dialog-title>Update customer?</h1>
<mat-dialog-content>
  <p class="secondary-text sub-title">
    You are updating customer:
  </p>
  <div class="content">
    <div fxLayout="row wrap" fxFlex="100">

      <div *ngIf="data.form.controls.firstName && !data.form.controls.firstName.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.firstName || 'Null'}}</div>
        <div class="mat-caption"> First name </div>
      </div>

      <div *ngIf="data.form.controls.lastName && !data.form.controls.lastName.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.lastName || 'Null'}}</div>
        <div class="mat-caption"> Last name </div>
      </div>

      <div *ngIf="data.form.controls.email && !data.form.controls.email.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.email || 'Null'}}</div>
        <div class="mat-caption"> Email </div>
      </div>

      <div *ngIf="data.form.controls.ssn && !data.form.controls.ssn.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{data.form.value.ssn || 'Null'}}</div>
        <div class="mat-caption"> Social security number </div>
      </div>

      <div *ngIf="data.form.controls.status && !data.form.controls.status.pristine" fxLayout="column" fxFlex="100"
        fxFlex.gt-sm="50" class="layout padding-vertical-md">
        <div>{{statusName(data.form.value.status) || 'Null'}}</div>
        <div class="mat-caption"> Status </div>
      </div>

    </div>
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="flex row end-center">
  <button mat-button [mat-dialog-close]="false">Cancel</button>
  <button mat-button [mat-dialog-close]="true" color="primary">Ok</button>
</div>